import GoogleLogin from "../../../../../components/Buttons/GoogleLogin";
import { useState } from "react";
import LoginForm from "./LoginForm";
import SignUpForm from "./SignUpForm";
import { Modal } from "@mui/material";
import auth from "../../../../../components/Layout/util/auth";
import TagManager from "react-gtm-module";

const LoginOrSignup = ({ toggleSnackbar, recaptchaRef }) => {
  const [isSignUp, setIsSignUp] = useState(false);
  const r = auth();

  const handleGooglelogin = () => {
    if (r?.token) {
      const tagManagerArgs = {
        dataLayer: {
          event: "ctaClicks",
          userStatus: "loggedIn",
          ctaName: "Sign up with Google",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    } else {
      const tagManagerArgs = {
        dataLayer: {
          event: "ctaClicks",
          userStatus: "Guest",
          ctaName: "Sign up with Google",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    }
  };

  const handleSignup = () => {
    setIsSignUp(true);
    if (r?.token) {
      const tagManagerArgs = {
        dataLayer: {
          event: "ctaClicks",
          userStatus: "loggedIn",
          ctaName: "Create an Account",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    } else {
      const tagManagerArgs = {
        dataLayer: {
          event: "ctaClicks",
          userStatus: "Guest",
          ctaName: "Create an Account",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    }
  };

  const handleSignin = () => {
    setIsSignUp(false);
    if (r?.token) {
      const tagManagerArgs = {
        dataLayer: {
          event: "ctaClicks",
          userStatus: "loggedIn",
          ctaName: "Sign In",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    } else {
      const tagManagerArgs = {
        dataLayer: {
          event: "ctaClicks",
          userStatus: "Guest",
          ctaName: "Sign In",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    }
  };

  return (
    <div className="box">
      <div className="login-container">
        <div
          className="logo-login01"
          style={{ display: "flex", alignItems: "center" }}
        >
          {/* <img src="https://fantiger.com/images/home/logo-icon.png" alt="" /> */}
          <img
            style={{ marginLeft: "-12px" }}
            src="/images/login/Web-Logo.png"
            alt=""
          />
          <div style={{ marginLeft: "10px", whiteSpace: "nowrap" }}>
            <h2>{isSignUp ? "Sign Up" : "Login"}</h2>
            {/* <p style={{ fontSize: "12px" }}>
              Get early access and see your growth!
            </p> */}
          </div>
        </div>

        {isSignUp ? (
          <SignUpForm
            toggleSnackbar={toggleSnackbar}
            recaptchaRef={recaptchaRef}
            setIsSignUp={setIsSignUp}
          />
        ) : (
          <LoginForm toggleSnackbar={toggleSnackbar} />
        )}

        <div className="login-button01">
          {isSignUp ? (
            <p className="g-term">Or Sign up with Google</p>
          ) : (
            <p className="g-term">Or Sign in with Google</p>
          )}
        </div>
        <div className="google-button01" onClick={() => handleGooglelogin()}>
          <GoogleLogin
            text={isSignUp ? "Sign up with Google" : "Sign in with Google"}
          />
        </div>
        <div className="create-acc">
          {isSignUp ? (
            <p>
              Already have an account?
              <a href="#" onClick={() => handleSignin()}>
                {" "}
                Sign In{" "}
              </a>
            </p>
          ) : (
            <p>
              Not Registered yet?{" "}
              <a href="#" onClick={() => handleSignup()}>
                Create an Account
              </a>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginOrSignup;
